import { put, select } from 'redux-saga/effects'
import { takeLatest } from '@redux-saga/core/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { setAddCardiacToTimeline } from '../store/quickActions.actions'
import { resetState } from '../../procedures/cardiac/store/cardiac.actions'
import { addCardiacItem } from '../../timeline/store/timeline.actions'
import { CardiacConstants } from '../../procedures/cardiac/store/cardiac.constants'

export function* saveCardiacQuickActionTimeLineRow() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { addCardiacToTimeline } = quickActionsObject
  if (addCardiacToTimeline) {
    yield put(addCardiacItem())
    yield put(setAddCardiacToTimeline(false))
    yield put(resetState())
  }
}

export function* saveCardiacQuickActionTimeLineRowSaga() {
  yield takeLatest([CardiacConstants.SET_ADD_TO_TIMELINE], saveCardiacQuickActionTimeLineRow)
}
